import React, { useState } from "react";
import {
  Modal,
  Table,
  Button,
  Space,
} from "antd";
import { EyeOutlined } from '@ant-design/icons';
import { limitWords } from "../../utils/utils";
import { Tooltip } from "antd";
import ClausesPreviewModal from "./clausePreviewModal";
import EditClauseOrderModal from "./editClauseOrderModal";
import axiosInstance from "../../utils/axiosInstance";

const ClausesModal = ({
  visible,
  onCancel,
  clausesData,
  masterClausesData,
  okText,
  loading,
  onSubmit,
  directSubmit,
}) => {
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [openAllClausePreview, setOpenAllClausePreview] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedMasterRowKeys, setSelectedMasterRowKeys] = useState([]);
  const [previewData, setPreviewData] = useState(1); // Initial sequence value
  const [selectedSequence, setSelectedSequence] = useState([]); 
  const [globalSequenceMap, setGlobalSequenceMap] = useState({});


const handleSelectionUpdate = (allClauseKeys, allMasterKeys) => {
  const combinedKeys = [...allClauseKeys, ...allMasterKeys];

  // Maintain previous order where possible
  const newSequence = selectedSequence.filter((id) => combinedKeys.includes(id));

  // Add new selections in order
  combinedKeys.forEach((id) => {
    if (!newSequence.includes(id)) {
      newSequence.push(id);
    }
  });

  // Build updated sequence map
  const newMap = {};
  newSequence.forEach((id, index) => {
    newMap[id] = index + 1;
  });

  setSelectedSequence(newSequence);
  setGlobalSequenceMap(newMap);
};

const onSelectChange = (keys) => {
  setSelectedRowKeys(keys);
  handleSelectionUpdate(keys, selectedMasterRowKeys);
};

const onMasterSelectChange = (keys) => {
  setSelectedMasterRowKeys(keys);
  handleSelectionUpdate(selectedRowKeys, keys);
};


const resetAllStates = () => {
  setSelectedRowKeys([]);
  setSelectedMasterRowKeys([]);
  setSelectedSequence([]);
  setGlobalSequenceMap({});
};

  console.log(globalSequenceMap, "globalSequenceMap")


  const rowSelection = { selectedRowKeys, onChange: onSelectChange, };
  const masterRowSelection = { selectedMasterRowKeys, onChange: onMasterSelectChange, };

const allClauses = [...selectedRowKeys, ...selectedMasterRowKeys].map((id) => {
  const data = clausesData.find(item => item.id === id) || masterClausesData.find(item => item.id === id);
  
  return {
    clause_id: id,
    clause_name: data?.clause_name || "",
    clause_order: globalSequenceMap[id],
  };
});


  const fetchPrewviewData = async (clause_id) => {
    try {
      // setIsLoading(true);
      setPreviewLoading(true);
      const response = await axiosInstance.get(`/contract/clauser-preview/`, { customParams: { clause_id } })
      setPreviewData(response.data.data);
      setPreviewLoading(false);
    } catch (error) {
      // setIsLoading(false);
      setPreviewLoading(false);
    }
  };

  const masterClauseColumns = [
    {
      title: "Clause name",
      dataIndex: "clause_name",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Implementation Instances",
      dataIndex: "implementation_instances",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Preview",
      dataIndex: "template_file",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setShowPreviewModal(true);
              fetchPrewviewData(record.id);
            }}
          >
            <EyeOutlined  />
          </Button>
          <ClausesPreviewModal
            visible={showPreviewModal}
            onCancel={onCancelPreviewModal}
            data={previewData && previewData}
            loading={previewLoading}
          />
        </Space>
      ),
    },
  ];

  const clauseColumns = [
    {
      title: "Clause name",
      dataIndex: "clause_name",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Implementation Instances",
      dataIndex: "implementation_instances",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => (
        <Tooltip title={text}>
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {limitWords(text, 6)}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Preview",
      dataIndex: "template_file",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setShowPreviewModal(true);
              fetchPrewviewData(record.id);
            }}
          >
            <EyeOutlined  />
          </Button>
          <ClausesPreviewModal
            visible={showPreviewModal}
            onCancel={onCancelPreviewModal}
            data={previewData && previewData}
          />
        </Space>
      ),
    },
  ];

  const handlePreviewAndSubmit = () => {
    setOpenAllClausePreview(true);
  };
  const onCancelPreviewModal = () => {
    setShowPreviewModal(false);
    setPreviewData(null);
  };

  const handlePreviewModalSubmit = (data) => {
    setOpenAllClausePreview(false);
    onSubmit(data);
    resetAllStates();
    setTimeout(() => {
      onCancel();
    }, 1000);
  };

  return (
    <Modal
      visible={visible}
      destroyOnClose={true}
      title="Select one or multiple Clauses"
      onCancel={() => {
        onCancel();
        resetAllStates();
      }}
      className="clause-modal"
      footer={[
        <Button key="cancel" onClick={() => {
          onCancel();
          resetAllStates(); // 👈 here too
        }}>
          Cancel
        </Button>,
        directSubmit ? (
          <Button
            key="save"
            type="primary"
            onClick={() => {
              // const data = allClauses.map((clause) => clause.clause_id);
              onSubmit(allClauses && allClauses);
              // onCancel();
            }}
            loading={loading && loading}
          >
            {okText ? okText : "Submit"}
          </Button>
        ) : (
          <Button
            key="save"
            type="primary"
            onClick={handlePreviewAndSubmit}
            loading={loading && loading}
            disabled={Object.keys(globalSequenceMap).length === 0}

          >
            {okText ? okText : "Preview"}
          </Button>
        ),
        <EditClauseOrderModal
          data={allClauses && allClauses}
          visible={openAllClausePreview}
          onCancel={() => setOpenAllClausePreview(false)}
          onSubmit={handlePreviewModalSubmit}
          loading={loading}
          clausesData={clausesData}
          masterClausesData={masterClausesData}

        />,
      ]}
    >
      <h1>Clauses</h1>
      <Table
        columns={clauseColumns}
        dataSource={clausesData}
        rowKey="id"
        pagination={true}
        scroll={{ x: "max-content" }}
        rowSelection={rowSelection}
      />
      <h1 className="mt-3">Master Clauses</h1>

      <Table
        columns={masterClauseColumns}
        dataSource={masterClausesData}
        rowSelection={masterRowSelection}
        rowKey="id"
        pagination={true}
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};

export default ClausesModal;
